














































































import { Inject } from '@cds/common';
import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { NuoxiaoerService } from '@/services/nuoxiaoer-service';  
import NotifyPopup from './NotifyPopup.vue';

@Component({
  components: {
    NotifyPopup,
  }
})
export default class NotifyList extends Vue {
  public queryForm: Record<string, any> = {
    pages: 1,
    size: 10,
    current: 1,
    total: 0,
    type: '0',
    createTimeRange: []
  }
  public isShowPopup: Boolean = false; // 是否显示通知popup
  public popupId: Number = null;
  public popupKey: number = 0; // 弹窗key，用于强制重新渲染
  public tableData: any[] = [];
  public loading: Boolean = true;

  @Inject(NuoxiaoerService) private nuoxiaoerService!: NuoxiaoerService;

  public async created(): Promise<void> {
    this.queryForm = {
      pages: 1,
      size: 10,
      current: 1,
      total: 0,
      type: '0',
      createTimeRange: []
    }
    await this.getList();
  }

  //查询接口
  public search() {
    this.queryForm.current = 1;
    this.getList()
  }

  //分页相关
  public handleSizeChange(size: number) {
    this.queryForm.size = size;
    this.getList();
  }

  public handleCurrentChange(current: number) {
    this.queryForm.current = current;
    this.getList();
  }

  //获取数据接口
  public async getList() {
    this.loading = true;
    let params: any = {
      type: this.queryForm.type=='0'?'': this.queryForm.type|| undefined,
      createDateStart: (this.queryForm.createTimeRange || [])[0],
      createDateEnd: (this.queryForm.createTimeRange || [])[1],
      current: this.queryForm.current,
      size: this.queryForm.size
    };

    try {
      const res = await this.nuoxiaoerService.fetchNotifyList(params);
      this.loading = false;

      const list = (res.records || []).map(x => {
        return {
          ...x,
          createdTime: x.createdTime ? moment(x.createdTime).format('YYYY-MM-DD HH:mm:ss') : '--',
          typeText: this.getTypeText(x.type)
        }
      });
      this.tableData = list;

      this.queryForm.total = res.total || 0;
      this.queryForm.pages = res.pages || 0;
      this.queryForm.size = res.size || 10;
      this.queryForm.current = res.current || 1;

    } catch (error) {
      this.loading = false;
      console.error('获取通知列表失败：', error);
      this.$message.error('获取列表数据失败，请稍后重试');
    }
  }

  // 获取类型显示文本
  private getTypeText(type: number): string {
    switch (type) {
      case 2:
        return '文档';
      case 3:
        return '智能问答';
      default:
        return '--';
    }
  }

  // 删除
  public async handleDelete(row: any) {
    try {
      // 确认删除
      await this.$confirm('是否删除该信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });

      // 删除数据
      await this.nuoxiaoerService.deleteNotify({ id: row.id });

      this.$message({
        message: '删除成功',
        type: 'success'
      });

      // 刷新列表
      this.getList();
    } catch (error) {
      if (error === 'cancel') {
        // 用户取消操作，不做处理
        return;
      }
      console.error('删除失败：', error);
      this.$message.error('删除失败：' + (error.message || '未知错误'));
    }
  }

  // 重置
  public reset() {
    this.queryForm = {
      pages: 1,
      size: 10,
      current: 1,
      total: 0,
      type: '',
      createTimeRange: []
    };
    this.getList()
  }


  /* 打开popup */
  public handleOpenPopup(rowData:any) {
    if (!rowData) {
      console.log('新增');
      this.popupId = null;
      this.isShowPopup = true;
    } else {
      console.log('编辑 rowData:', rowData);
      this.popupId = rowData.id;
      this.isShowPopup = true;
    }
    // 强制更新popupKey，重新渲染弹窗组件
    this.popupKey += 1;
  }

  /* 保存后 */
  public handleAfterSaved() {
    console.log('handleAfterSaved');
    this.getList();
    this.isShowPopup = false;
    this.popupId = null;
  }

  /* 取消popup */
  public handleCancelPopup() {
    this.isShowPopup = false;
    this.popupId = null;
  }

   /* 关闭popup后 */
  public handleAfterClosePopup() {
    this.popupId = null;
  }
}
